// extracted by mini-css-extract-plugin
module.exports = {"upload__title":"upload-module__upload__title___r-vL1","upload__text":"upload-module__upload__text___9OSR0"};